import StudentsPathways from './StudentsPathways'

export default StudentsPathways
